module.exports = __webpack_public_path__ + "img/kh.8c01273.svg";